import React, { useState, useEffect } from "react";
import {
  Typography,
  TextField,
  Button,
  Grid,
  Stepper,
  Step,
  StepLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox
} from "@mui/material";
import StepCircle from "../StepCircle";
import api from "../../api";

const steps = ["Datos del Mantenimiento", "Asignar Vehículo"];

const EditarMantenimiento = ({ mantenimiento, handleClose, onUpdate }) => {
  const [step, setStep] = useState(0);
  const [vehiculos, setVehiculos] = useState([]);
  const [isStep1Valid, setIsStep1Valid] = useState(false);

  const [mantenimientoData, setMantenimientoData] = useState({
    descripcion: "",
    monto: "",
    taller: "",
    solicitud: "",
    fecha_requerimiento: "",
    rta_ccoo: "",
    estado_reparacion: "",
    fecha_ingreso: "",
    fecha_egreso: "",
    abonado: false,
    nro_factura: "",
    tramix_nro: "",
    cargado_en_ficha_tec: false,
    vehiculo: "",
  });

  useEffect(() => {
    api.get("vehiculos/")
      .then((response) => setVehiculos(response.data))
      .catch(() => alert("Error al cargar vehículos."));
  }, []);

  useEffect(() => {
    if (mantenimiento) {
      setMantenimientoData({
        descripcion: mantenimiento.descripcion || "",
        monto: mantenimiento.monto ?? "",
        taller: mantenimiento.taller ?? "",
        solicitud: mantenimiento.solicitud ?? "",
        fecha_requerimiento: mantenimiento.fecha_requerimiento ?? "",
        rta_ccoo: mantenimiento.rta_ccoo ?? "",
        estado_reparacion: mantenimiento.estado_reparacion ?? "",
        fecha_ingreso: mantenimiento.fecha_ingreso ?? "",
        fecha_egreso: mantenimiento.fecha_egreso ?? "",
        abonado: mantenimiento.abonado ?? false,
        nro_factura: mantenimiento.nro_factura ?? "",
        tramix_nro: mantenimiento.tramix_nro ?? "",
        cargado_en_ficha_tec: mantenimiento.cargado_en_ficha_tec ?? false,
        vehiculo: mantenimiento.vehiculo ?? "", // si ya lo cargás en otro lado podés omitir
      });
    }
  }, [mantenimiento]);

  useEffect(() => {
    const { descripcion, monto } = mantenimientoData;
    setIsStep1Valid(descripcion && monto);
  }, [mantenimientoData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setMantenimientoData({
      ...mantenimientoData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleNext = () => setStep((prev) => prev + 1);
  const handleBack = () => setStep((prev) => prev - 1);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Enviando datos:", mantenimientoData);

    const formattedData = {
      ...mantenimientoData,
      fecha_ingreso: mantenimientoData.fecha_ingreso
        ? new Date(mantenimientoData.fecha_ingreso).toISOString().split('T')[0]
        : null,
      fecha_egreso: mantenimientoData.fecha_egreso
        ? new Date(mantenimientoData.fecha_egreso).toISOString().split('T')[0]
        : null,
    };


    api.put(`mantenimiento/${mantenimiento.id}/`, formattedData)
      .then((res) => {
        alert("Mantenimiento actualizado correctamente");
        if (onUpdate) {
          onUpdate(res.data); // send the new data to parent
        }
        handleClose();
      })
      .catch((err) => {
        console.error("Error al actualizar mantenimiento:", err.response?.data || err.message);
        alert("Hubo un error al actualizar el mantenimiento.");
      });
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "700px", margin: "0 auto" }}>
      <Typography variant="h6" style={{ color: "#152d51", fontWeight: "bold" }}>
        Editar Mantenimiento
      </Typography>

      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={StepCircle}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {step === 0 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <TextField
              label="Descripción"
              name="descripcion"
              value={mantenimientoData.descripcion}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Monto"
              name="monto"
              type="number"
              value={mantenimientoData.monto}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Taller"
              name="taller"
              value={mantenimientoData.taller}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Solicitud"
              name="solicitud"
              value={mantenimientoData.solicitud}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Fecha de Requerimiento"
              name="fecha_requerimiento"
              type="date"
              value={mantenimientoData.fecha_requerimiento}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="RTA CCOO"
              name="rta_ccoo"
              value={mantenimientoData.rta_ccoo}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Estado Reparación"
              name="estado_reparacion"
              value={mantenimientoData.estado_reparacion}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Fecha Ingreso"
              name="fecha_ingreso"
              type="date"
              value={mantenimientoData.fecha_ingreso}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Fecha Egreso"
              name="fecha_egreso"
              type="date"
              value={mantenimientoData.fecha_egreso}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Nro. Factura"
              name="nro_factura"
              value={mantenimientoData.nro_factura}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Tramix Nro"
              name="tramix_nro"
              value={mantenimientoData.tramix_nro}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  name="abonado"
                  checked={mantenimientoData.abonado}
                  onChange={handleChange}
                />
              }
              label="¿Abonado?"
            />
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  name="cargado_en_ficha_tec"
                  checked={mantenimientoData.cargado_en_ficha_tec}
                  onChange={handleChange}
                />
              }
              label="¿Cargado en Ficha Técnica?"
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleNext}
              sx={{ background: "#152d51" }}
              disabled={!isStep1Valid}
            >
              Siguiente
            </Button>
          </Grid>
        </Grid>
      )}

      {step === 1 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel style={{ background: "white" }}>Vehículo Asignado</InputLabel>
              <Select
                name="vehiculo"
                value={mantenimientoData.vehiculo}
                onChange={handleChange}
              >
                <MenuItem value="">Sin vehículo</MenuItem>
                {vehiculos.map((v) => (
                  <MenuItem key={v.id} value={v.id}>
                    {v.patente} - {v.marca} {v.modelo}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" fullWidth onClick={handleBack}>
              Atrás
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ background: "#152d51" }}
            >
              Guardar Cambios
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default EditarMantenimiento;
